export default function NotFound() {
  return (
    <div className="container my-10 text-center">
      <h1>404</h1>
      <p>There's nothing here</p>
    </div>
  );
}
